import { motion } from 'framer-motion';
import { CSSProperties } from 'react';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

export default function ProgressBar({ currentStep, totalSteps }: ProgressBarProps) {
  const progress = (currentStep / totalSteps) * 100;

  const containerStyles: CSSProperties = {
    width: '100%',
    height: '8px',
    backgroundColor: 'var(--color-border)',
    borderRadius: '9999px',
    overflow: 'hidden',
    marginBottom: 'var(--spacing-xl)'
  };

  const barStyles: CSSProperties = {
    height: '100%',
    background: 'linear-gradient(90deg, var(--color-primary) 0%, var(--na-teal-light) 100%)',
    borderRadius: '9999px'
  };

  return (
    <div style={containerStyles}>
      <motion.div
        style={barStyles}
        initial={{ width: '0%' }}
        animate={{ width: `${progress}%` }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      />
    </div>
  );
}
